
export enum CourseActionTypes {
    FETCH_REQUEST = '@@Course/FETCH_REQUEST',
    FETCH_SUCCESS = '@@Course/FETCH_SUCCESS',
    FETCH_ERROR = '@@Course/FETCH_ERROR',

    SELECT = '@@Course/SELECT',
    SELECTED = '@@Course/SELECTED',
    CLEAR_SELECTED = '@@Course/CLEAR_SELECTED',
    ADD_SUCCESS = '@@Course/ADD_SUCCESS',

    EDIT = '@@Course/EDIT',
    UPDATE_EDIT = '@@Course/UPDATE_EDIT',
    EDIT_SUCCESS = '@@Course/EDIT_SUCCESS'
}

export interface CourseUIState {
    readonly loading: boolean
    readonly selected?: number
    readonly errors?: string
    readonly totDoc?: number

}